FiltersMdl.service( 'ColorFansSrv', ['$http', '$q', 'API_URL', function ( $http, $q, API_URL ) {

	var product_cat = null,
		effect_fan = null,
		colorFans = null;


	return {

		getColorFansByProductCat: function( product_cat_id ) {
			var deffered = $q.defer();


			if ( colorFans && product_cat == product_cat_id )
				deffered.resolve( colorFans );
			else {
				product_cat = product_cat_id;
				effect_fan = null;

				$http.get( API_URL.FAN + '/colors/' + product_cat_id ).then(
						function (response){
							colorFans = response.data;
							deffered.resolve( colorFans );
						},
						function (error){
							deffered.reject(error);
						}
				);
			}

			return deffered.promise;
		},

		getColorFansByEffectFan: function( effect_fan_id ) {
			var deffered = $q.defer();

			if ( colorFans && effect_fan == effect_fan_id )
				deffered.resolve( colorFans );
			else {
				effect_fan = effect_fan_id;
				product_cat = null;

				$http.get( API_URL.FAN + '/colors/effect/' + effect_fan_id ).then(
						function (response){
							colorFans = response.data;
							deffered.resolve( colorFans );
						},
						function (error){
							deffered.reject(error);
						}
				);
			}

			return deffered.promise;
		},
	}
}]);


